import "reflect-metadata";
import React from "react";
import { Root, createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";

import registerServiceWorker from "./service-worker/subscribe-notifications-service-worker";

import { App } from "~/view/app.component";

Sentry.init({
  dsn: "https://42e8129bd8866417dacc20ca18353002@o4508642186166272.ingest.de.sentry.io/4509164626837584",
  integrations: [
    // If you're using react router, use the integration for your react router version instead.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root: Root = createRoot(document.getElementById("root") as HTMLElement);

root.render(<App />);

if (process.env.NODE_ENV === "production") {
  registerServiceWorker();
}
